import { render } from "./submission-panel-supporter.vue?vue&type=template&id=050b81ea&scoped=true&ts=true"
import script from "./submission-panel-supporter.vue?vue&type=script&lang=ts"
export * from "./submission-panel-supporter.vue?vue&type=script&lang=ts"

import "./submission-panel-supporter.vue?vue&type=style&index=0&id=050b81ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050b81ea"]])

export default __exports__